import Masonry from 'masonry-layout'

const init = async (parent) => {
    return new Promise((resolve) => {
        const msnry = new Masonry(parent, {
            // options
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer'
        })

        // htmx.on('htmx:afterRequest', function (event) {
        //     setTimeout(() => {
        //         const msnry = new Masonry(parent, {
        //             // options
        //             itemSelector: '.grid-item',
        //             columnWidth: '.grid-sizer'
        //         })
        //     }, 1000)
        // })
        return resolve('Masonry loaded')
    })
}

export { init }
